import styled from "styled-components";

export const SOnboardingTourCardPopupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 20px 24px 20px;
`;
